export default __webpack_public_path__ + "static/media/vinted-marketplace-logo.b05ec719.png";